import type { ReactNode } from 'react';
import styles from './ContactRow.module.css';

export interface ContactItem {
  label: ReactNode;
  value: ReactNode;
}

interface ContactRowProps {
  items: ContactItem[];
}

export default function ContactRow({ items }: ContactRowProps) {
  return (
    <div className={styles.row}>
      {items.map((item, i) => (
        <div key={i} className={styles.item}>
          <span className={styles.label}>{item.label}</span>
          <div className={styles.value}>{item.value}</div>
        </div>
      ))}
    </div>
  );
}
